import {
  Alert,
  Box,
  Button,
  Card,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import LoadingIcon from "../components/LoadingIcon";
import TransactionTable from "../components/TransactionTable";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import emailjs from '@emailjs/browser';

const columns = [
  {
    name: "Amount",
    selector: (row) => (
      <div className={`text-red-600`}>- ${parseInt(row.amount).toFixed(2)}</div>
    ),
    sortable: true,
  },
  {
    name: "Withdrawal Method",
    selector: (row) => (
      <div>
        {row.withdrawalMethod === "10" && "Bank"}
        {row.withdrawalMethod === "20" && "Bitcoin"}
        {row.withdrawalMethod === "30" && "Etheruem"}
        {row.withdrawalMethod === "40" && "Litecoin"}
      </div>
    ),
  },
  {
    name: "Date",
    selector: (row) => new Date(row.createdAt).toDateString(),
    sortable: true,
  },
  {
    name: "Status",
    selector: (row) => (
      <div
        className={`${row.status === "pending" ? "text-red-600" : "text-green-600"
          } capitalize`}
      >
        {" "}
        {row.status}
      </div>
    ),
  },
];

const Withdrawal = () => {
  const [withdrawalOption, setWithdrawalOption] = React.useState(0);
  const [transactions, setTransactions] = useState([]);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [amount, setAmount] = useState();
  const [balance, setBalance] = useState(0.0);
  const [disable, setDisable] = useState(true);
  const [notificationType, setNotificationType] = useState("success");
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const token = localStorage.getItem("token");
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [otpVerified, ] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const vertical = "top";
  const horizontal = "center";

  const getActivity = useCallback(async () => {
    setLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}activity/withdraw`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token,
        },
      }
    );

    const response1 = await fetch(
      `${process.env.REACT_APP_API_URL}customerDetails`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token,
        },
      }
    );

    const data1 = await response1.json();
    const data = await response.json();

    setUser(data1.User);

    if (data.status) {
      setTransactions(data.userTransactions);
      setBalance(data.userBalance);
    }
    setLoading(false);
  }, [token]);

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setLoadingOtp(true);
    console.log({
      email: user.email,
      amount,
    });

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}verify-otp-withdrawal`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({
          otp,
        }),
      }
    );

    const data = await response.json();
    console.log(data);

    if (data.status) {
      // setLoadingOtp(false);
      // setOtpVerified(true);
      // setShowOtp(false);
      if (parseInt(amount) > balance) {
        setShowNotification(true);
        setNotificationType("error");
        setMessage("Insufficient Balance");
        setTimeout(() => setShowNotification(false), 4000);
      } else {
        setButtonLoading(true);
        console.log({
          email: user.email,
          amount,
        });
        const response = await fetch(`${process.env.REACT_APP_API_URL}withdraw`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            withdrawalOption,
            amount,
          }),
        });

        const data = await response.json();

        if (data.status) {
          setAmount("");
          setShowNotification(true);
          setNotificationType("success");
          setMessage("Your withdrawal is being processed");
          var templateParams = {
            email: user.email,
            amount,
          };

          emailjs.send('service_g6j6yn1', 'template_1yrytmq', templateParams,'NAPNHamidy0LjKTr7').then(
            (response) => {
              console.log('SUCCESS!', response.status, response.text);
            },
            (error) => {
              console.log('FAILED...', error);
            },
          );
        } else {
          setShowNotification(true);
          setNotificationType("error");
          setMessage("Oops! An Error occured. Try again later");
        }
        setLoading(false);
        setButtonLoading(false);
        setTimeout(() => {
          setShowNotification(false);
          window.location.reload();
        }, 4000);
      }
    } else {
      setLoadingOtp(false);
      setShowNotification(true);
      setNotificationType("error");
      setMessage("Invalid OTP, please try again");
      setTimeout(() => setShowNotification(false), 4000);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otpVerified) {
      setShowOtp(true);
      return;
    }

    // if (parseInt(amount) > balance) {
    //   setShowNotification(true);
    //   setNotificationType("error");
    //   setMessage("Insufficient Balance");
    //   setTimeout(() => setShowNotification(false), 4000);
    // } else {
    //   setButtonLoading(true);
    //   const response = await fetch(`${process.env.REACT_APP_API_URL}withdraw`, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       token,
    //     },
    //     body: JSON.stringify({
    //       withdrawalOption,
    //       amount,
    //     }),
    //   });

    //   const data = await response.json();

    //   if (data.status) {
    //     setAmount("");
    //     setShowNotification(true);
    //     setNotificationType("success");
    //     setMessage("Your withdrawal is being processed");
    //   } else {
    //     setShowNotification(true);
    //     setNotificationType("error");
    //     setMessage("Oops! An Error occured. Try again later");
    //   }
    //   setLoading(false);
    //   setButtonLoading(false);
    //   setTimeout(() => {
    //     setShowNotification(false);
    //     window.location.reload();
    //   }, 4000);
    // }
  };

  useEffect(() => {
    getActivity();
  }, [getActivity]);

  const handleChange = (event) => {
    setWithdrawalOption(parseInt(event.target.value));
  };

  return (
    <div className="h-screen">
      <div className="mb-9">
        <h3 className="font-bold text-2xl text-white">Withdrawal</h3>
      </div>
      <Snackbar
        open={showNotification}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert message={message} severity={notificationType}>
          {message}
        </Alert>
      </Snackbar>
      {loading ? (
        <div className="h-screen flex items-center justify-center">
          <LoadingIcon />
        </div>
      ) : showOtp ? (
        <div className="w-full md:w-1/3 mx-auto bg-white p-5 rounded">
          <h3 className="text-black mb-4 text-center text-2xl font-bold">
            Enter OTP
          </h3>
          <div>
            Enter your OTP, if you do not have an OTP, please contact support
          </div>
          <form onSubmit={handleOtpSubmit}>
            <FormControl fullWidth sx={{ m: 1 }} variant="standard">
              <InputLabel htmlFor="standard-adornment-otp">OTP</InputLabel>
              <Input
                id="standard-adornment-otp"
                className="text-black"
                required
                type="number"
                onChange={(e) => setOtp(e.target.value)}
                disabled={loadingOtp}
              />
            </FormControl>
            <div className="mt-4 flex justify-center">
              <Button
                size="large"
                variant="contained"
                className="md:w-1/2 w-full !bg-[#1B4242]"
                type="submit"
                disabled={loadingOtp}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      ) : (
        <>
          <Snackbar
            open={showNotification}
            autoHideDuration={6000}
            anchorOrigin={{ vertical, horizontal }}
          >
            <Alert message={message} severity={notificationType}>
              {message}
            </Alert>
          </Snackbar>
          <div className="mb-9">
            <h6 className="font-bold text-white">
              Amount Available for Withdrawal:{" "}
              <span className="text-green-600">${balance}</span>{" "}
            </h6>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="md:flex">
              <Card variant="outlined" className="p-3 w-full !bg-[#1B4242]">
                <div className="mb-4">
                  <h3 className="text-lg text-white">
                    Enter Amount to Withdraw
                  </h3>
                </div>
                <FormControl
                  fullWidth
                  sx={{ m: 1 }}
                  variant="standard"
                  className="!text-white"
                >
                  <InputLabel htmlFor="standard-adornment-amount">
                    Amount
                  </InputLabel>
                  <Input
                    id="standard-adornment-amount"
                    required
                    // className={parseInt(amount) > balance ? "bg-red-700" : ""}
                    type="number"
                    className="text-white"
                    onChange={(e) => setAmount(e.target.value)}
                    startAdornment={
                      <InputAdornment position="start" className="!text-white">
                        $
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Card>
              <div className="mx-2 mb-8"></div>
              <Card variant="outlined" className="p-3 w-full !bg-[#1B4242]">
                <div className="mb-4">
                  <h3 className="text-lg text-white">Select Payment Method</h3>
                </div>
                <Box sx={{ minWidth: 120, marginBottom: 2 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Select Payment Method
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={withdrawalOption}
                      label="Select Payment Method"
                      onChange={handleChange}
                      className="!text-white"
                      required
                    >
                      <MenuItem value={0}>
                        <em>None</em>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          if (
                            user.bankName.length > 0 &&
                            user.accountName.length > 0 &&
                            user.accountNumber.length > 0
                          ) {
                            setDisable(false);
                          } else {
                            setDisable(true);
                          }
                        }}
                        value={10}
                      >
                        Bank
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          if (user.btcWallet.length > 0) {
                            setDisable(false);
                          } else {
                            setDisable(true);
                          }
                        }}
                        value={20}
                      >
                        Bitcoin
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          if (user.ethWallet.length > 0) {
                            setDisable(false);
                          } else {
                            setDisable(true);
                          }
                        }}
                        value={30}
                      >
                        Ethereum
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          if (user.litecoinWallet.length > 0) {
                            setDisable(false);
                          } else {
                            setDisable(true);
                          }
                        }}
                        value={40}
                      >
                        Litecoin
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <div className="row">
                  {withdrawalOption === 10 &&
                    user.bankName.length > 0 &&
                    user.accountName.length > 0 &&
                    user.accountNumber.length > 0 && (
                      <>
                        <div className="col-md-12 mb-2">
                          <Form.Group controlId="bankName">
                            <Form.Label>Bank Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Bank Name"
                              value={user.bankName}
                              readOnly
                              disabled
                              name="bankName"
                              required
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-12 mb-2">
                          <Form.Group controlId="accountName">
                            <Form.Label>Account Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Account Name"
                              value={user.accountName}
                              readOnly
                              disabled
                              name="accountName"
                              required
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-12 mb-2">
                          <Form.Group controlId="accountNumber">
                            <Form.Label>Account Number</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Account Number"
                              value={user.accountNumber}
                              readOnly
                              disabled
                              name="accountNumber"
                              required
                            />
                          </Form.Group>
                        </div>
                      </>
                    )}
                  {withdrawalOption === 20 && user.btcWallet.length > 0 ? (
                    <>
                      <div className="col-md-12 mb-2">
                        <Form.Group controlId="btcWallet">
                          <Form.Label>Bitcoin Wallet</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Bitcoin Wallet"
                            value={user.btcWallet}
                            readOnly
                            disabled
                            name="btcWallet"
                            required
                          />
                        </Form.Group>
                      </div>
                    </>
                  ) : (
                    () => setDisable(false)
                  )}
                  {withdrawalOption === 30 && user.ethWallet.length > 0 && (
                    <>
                      <div className="col-md-12 mb-2">
                        <Form.Group controlId="ethWallet">
                          <Form.Label>Ethereum Wallet</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Ethereum Wallet"
                            value={user.ethWallet}
                            readOnly
                            disabled
                            name="ethWallet"
                            required
                          />
                        </Form.Group>
                      </div>
                    </>
                  )}

                  {withdrawalOption === 40 &&
                    user.litecoinWallet.length > 0 && (
                      <>
                        <div className="col-md-12 mb-4">
                          <Form.Group controlId="litecoinWallet">
                            <Form.Label>Litecoin Wallet</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Litecoin Wallet"
                              value={user.litecoinWallet}
                              disabled
                              readOnly
                              name="litecoinWallet"
                              required
                            />
                          </Form.Group>
                        </div>
                      </>
                    )}
                </div>
                <div className="mt-2 text-white">
                  Click <Link to={"/profile?2"}>here</Link> to Add or Edit
                  withdrawal method
                </div>
              </Card>
            </div>
            <div className="mt-10 flex justify-center">
              {user.verified ? (
                buttonLoading ? (
                  <Button className="w-full">
                    <LoadingIcon />
                  </Button>
                ) : (
                  <Button
                    size="large"
                    variant="contained"
                    className="md:w-1/2 w-full !bg-[#1B4242]"
                    type="submit"
                    disabled={disable}
                  >
                    Withdraw
                  </Button>
                )
              ) : (
                <div className="text-lg text-red-600">
                  Kindly verify your account to be eligible for a withdrawal
                </div>
              )}
            </div>
          </form>
          <div className="mt-10">
            <div className="mb-9">
              <h6 className="font-bold text-2xl text-center text-white">
                Withdrawal History
              </h6>
            </div>

            <TransactionTable columns={columns} transactions={transactions} />
          </div>
        </>
      )}
    </div>
  );
};

export default Withdrawal;
